import React from "react";

const VerifyEmail = (props) => {
  const handleEmailVerification = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let urlToken = props.urlparams.params.token;
    let urldata = {
      token: urlToken,
    };
    props.apis.apiCustomerVerifyEmailWithToken(urldata).then((res) => {
      swal2.fire({
        title: "Your Email Address is successfully Verified!",
        text: "You can now close this window",
        icon: "success",
        iconColor: "#FF4D4D",
        showConfirmButton: false,
        showCancelButton: false,
      });
    });
  };

  return (
    <>
      <div className="container-fluid customer_verify_email_container">
        <div className="card p-4">
          <div className="row py-5">
            <div className="col-12 text-center">
              <img
                src={imagepaths.emailVerificationIcon}
                alt="emailVerificationIcon"
                className="img-fluid mb-4"
              />
              <h2 className="mb-2">Verify your email address</h2>
              <p className="">
                Please verify this email address by clicking button below.
              </p>
              <button
                type="button"
                className="btn btn-primary my-4"
                onClick={(...args) => handleEmailVerification(...args)}
              >
                Verify your email
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(VerifyEmail);
